// apps/landing-page/src/app/tests/constants.ts
//
// Deliberately NOT in TestsCatalogClient.tsx. That file is a 'use client' module, and while
// components imported across the client boundary work (they become client references), plain
// values do not — reading PAGE_SIZE from it inside the Server Component resolved to undefined,
// so `modules.slice(0, PAGE_SIZE)` silently returned an empty array and the server-rendered
// grid shipped empty. It type-checked and built cleanly, which is what made it easy to miss.

/** Modules per page in the catalog. The server-rendered shell renders exactly this many so
 *  hydration doesn't shift the layout. */
export const PAGE_SIZE = 8;
